import React, { useState } from 'react';
import { Box, Card, CardContent, Grid, TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Chip, FormControl, InputLabel, Select, MenuItem, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { Download, Calculate, Refresh, TrendingUp } from '@mui/icons-material';
import { Restore as RestoreIcon, Edit as EditIcon } from "@mui/icons-material";
import { variableRateData, loanInputData } from '../data/mockData';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import '../styles/VariableRate.scss';
import '../styles/loanCommon.scss';
import LoanInputParameters from './LoanInputParameters';
import { trackActivity } from '../../../../utils/mixpanel';

const VariableRate = ({ loanType, onLoanTypeChange }) => {
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: 'Variable Rate', page_type: page_type })
    }

    const [scheduleData] = useState(variableRateData);
    const [inputData, setInputData] = useState({
        ...loanInputData,
    });
    const [error, setError] = useState({});
    const [openDialog, setOpenDialog] = useState({ modal: false });

    const onRestErrorKey = (key) => {
        setError((prev) => ({ ...prev, [key]: '' }));
    };

    const onFieldChange = (key, value) => {
        setInputData({ ...inputData, [key]: value });
        setError((prev) => ({ ...prev, [key]: '' }));
    };

    const handleCalculate = () => {
        alert('Calculation logic will be implemented');
    };

    const handleExport = (format) => {
        alert(`Exporting schedule as ${format}`);
    };

    const handleSaveVariableRate = () => {
        alert('Added successfully');
        setOpenDialog(false);
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0
        }).format(amount);
    };

    return (
        <Box className="variable-rate-container">
            {/* Input Form */}
            <Card className="input-form-card">
                <CardContent>
                    <Box className="table-header">
                        <Typography className='loan-heading'>Loan Input Parameters</Typography>
                        <Box className="export-buttons">
                            <Tooltip arrow title="Revision History"><RestoreIcon className="revision-history" sx={{ cursor: 'pointer' }} onClick={() => handleItemClicked('RevisionHistoryIcon')} fontSize='small' color='primary' /></Tooltip>
                            <Tooltip arrow title="Edit"><EditIcon sx={{ cursor: 'pointer' }} onClick={() => { setOpenDialog({ modal: true }); handleItemClicked('EditIcon') }} fontSize='small' color='primary' /></Tooltip>
                        </Box>
                    </Box>
                    <Grid container spacing={3}>
                        <LoanInputParameters inputData={inputData} handleInputChange={onFieldChange} loanType={loanType} onLoanTypeChange={onLoanTypeChange} type={'view'} />
                    </Grid>
                </CardContent>
            </Card>

            {/* Schedule Table */}
            <Card className="table-card">
                <CardContent>
                    <Box className="table-header">
                        <Typography className='loan-heading'>Variable Interest Rate Schedule</Typography>
                        <Box className="export-buttons">
                            <Button startIcon={<ArrowDownwardIcon />} variant="outlined" size='small' onClick={() => handleItemClicked('Export Button')}> Export </Button>
                        </Box>
                    </Box>
                    <TableContainer component={Paper} className="variable-rate-table lease-detail-table">
                        <Table stickyHeader className="mui-table-format">
                            <TableHead>
                                <TableRow>
                                    <TableCell  sx={{minWidth: '130px'}}>Month</TableCell>
                                    <TableCell  sx={{minWidth: '130px'}}>Date</TableCell>
                                    <TableCell align="left"  sx={{minWidth: '130px'}}>Rent</TableCell>
                                    <TableCell align="left"  sx={{minWidth: '130px'}}>Debt Service</TableCell>
                                    <TableCell align="left"  sx={{minWidth: '130px'}}>Interest Rate</TableCell>
                                    <TableCell align="left"  sx={{minWidth: '130px'}}>Interest</TableCell>
                                    <TableCell align="left"  sx={{minWidth: '130px'}}>Principal</TableCell>
                                    <TableCell align="left"  sx={{minWidth: '130px'}}>Outstanding</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {scheduleData.map((row) => (
                                    <TableRow
                                        key={row.month}
                                        hover
                                        className={row.rateChanged ? 'rate-changed-row' : ''}
                                    >
                                        <TableCell>{row.month}</TableCell>
                                        <TableCell>{row.date}</TableCell>
                                        <TableCell align="left">{formatCurrency(row.rent)}</TableCell>
                                        <TableCell align="left">{formatCurrency(row.debtService)}</TableCell>
                                        <TableCell align="left">
                                            {row.rateChanged ? (
                                                <Chip
                                                    icon={<TrendingUp />}
                                                    label={`${row.interestRate}%`}
                                                    color="warning"
                                                    size="small"
                                                />
                                            ) : `${row.interestRate}%`}
                                        </TableCell>
                                        <TableCell align="left">{formatCurrency(row.interest)}</TableCell>
                                        <TableCell align="left">{formatCurrency(row.principalRepayment)}</TableCell>
                                        <TableCell align="left" className="outstanding-balance">
                                            {formatCurrency(row.principalOutstanding)}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </CardContent>
            </Card>

            {openDialog?.modal ? <Dialog aria-labelledby="customized-dialog-title" className='add-lease-dialog' maxWidth='md' open={true}>
                <DialogTitle className='dialog-header'>Edit Varibale Rate</DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <LoanInputParameters type={'edit'} inputData={inputData} loanType={loanType} onLoanTypeChange={onLoanTypeChange} onRestErrorKey={onRestErrorKey} error={error}/>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setOpenDialog({ modal: false }); handleItemClicked('Cancel Button') }} size='small'>Cancel</Button>
                    <Button onClick={() => { handleSaveVariableRate(); handleItemClicked('Save Button') }} variant="contained" color="primary" size='small'>Save</Button>
                </DialogActions>
            </Dialog> : null}
        </Box>
    );
};

export default VariableRate;